import * as React from 'react';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import Typography from '@mui/material/Typography';


export default function InfoPaper(props) {
const {title, number, bgcolor, ...others } = props
  return (
    <Card sx={{ minWidth: 275, height:240, bgcolor, ...others }}>
      <CardContent>
        <Typography sx={{ fontSize: 24 }} color="text.secondary" gutterBottom>
          {title}
        </Typography>
        <Typography variant="h1" component="div">
          {number || '-'}
        </Typography>
      </CardContent>
      {/* <CardActions>
        <Button size="small">Learn More</Button>
      </CardActions> */}
    </Card>
  );
}